import { buildUUIDPairs } from './buildUUIDPairs';
import { setSectorBlockFilters } from './setSectorBlockFilters';
import { setWidgetsFilterData } from './setWidgetsFilterData';
import { IgetFiltersByPairs, IMappingPairItem } from './types';

export const getFiltersByPairs = ({
   mapping, profileType, selectedProducts, selectedRegions,
}: IgetFiltersByPairs) => {
  let filters: IMappingPairItem = {
    sectorBlock: true,
    getChartBy: null,
    getTopCompaniesBy: null,
    getDealsBy: null,
  };

  const pairs = buildUUIDPairs({ selectedProducts, selectedRegions });

  filters = setSectorBlockFilters({ profileType, pairs, mapping, filters });

  filters = setWidgetsFilterData(filters);

  return filters;
};
